import { signal } from 'services/SignalsService'
export default class WinModel {
  constructor() {
    this._data = {
      totalWin: 0,
      linesWin: 0,
      winLines: [],
      winType: '',
      bet: 0,

      expendingMatrix: [],
      expendingWinLines: [],
      expendingWin: 0,
      expendingWinType: '',

      wild: [],
      respinWin: 0,

      multiply: {
        layoutx: false,
        value: 1,
        win: 0,
      },
    }
    this.isWin = false
    signal.on('STATE:IN:WIN', () => this.isWin = true)
    signal.on('STATE:OUT:WIN', () => this.isWin = false)
  }

  get() {
    return this._data
  }

  set(value) {

    if (value.win && value.current !== 'double') {
      this._data.bet = value.bet * value.lines
      this._data.winType = value.win.type
      this._data.linesWin = value.win.total
      this._data.totalWin = game.models.CascadeModel.get().isCascade ? value.debit : value.win.total
      this.makeWinLines(value.win.lines, 'winLines')
    }
    else {
      this._data.bet = value.bet
      this._data.winLines = []
      this._data.winType = ''
      this._data.totalWin = 0
      this._data.linesWin = 0

      if (!value.expandingWin){
        signal.dispatch('BALANCE:SERVER:UPDATE')
      }
    }
    if (value.expandingWin) {
      this._data.expendingWin = value.expandingWin.win.total
      this._data.expendingWinType = value.expandingWin.win.type
      this._data.expendingMatrix = []
      value.expandingWin.matrix.forEach((row) => {
        row.forEach((sym, reel) => {
          this._data.expendingMatrix[reel] = this._data.expendingMatrix[reel] || []
          this._data.expendingMatrix[reel].push(sym)
        })
      })
      this.makeWinLines(value.expandingWin.win.lines, 'expendingWinLines')
    }
    else {
      this._data.expendingWin = 0
      this._data.expendingMatrix = []
      this._data.expendingWinLines = []
      this._data.expendingWinType = ''
    }

    if (value.features) {
      this._data.multiply.value = 1
      this._data.multiply.win = 0
      this._data.multiply.layoutx = false
      this._data.wild = []

      value.features.forEach((feature) => {
        switch (feature.type){
          case 'multiplier':
            this._data.multiply.value = feature.value
            if(feature.name && feature.name === 'layoutx'){
              this._data.multiply.layoutx = true
            }
            break
          case 'expandingSymbol':
            if(feature.name && feature.name === 'expandingWild'){
              this._data.wild = feature.positions.filter(([wild]) => this._data.winLines.find(({ path }) => path.find(([reel]) => reel === wild)))
            }
            else {
              this._data.wild = []
            }
            break
          default:

            break
        }

      })
    }
    else if(value.feature) {
      if (value.feature.expendingWild) {
        this._data.wild = value.feature.expendingWild.positions.filter(([wild]) => this._data.winLines.find(({ path }) => path.find(([reel]) => reel === wild)))
      }
      else {
        this._data.wild = []
      }
      if (value.feature.multiplier) {

        this._data.multiply.value = value.feature.multiplier.value
        this._data.linesWin = this._data.totalWin / this._data.multiply.value
        this._data.multiply.win = this._data.totalWin - this._data.linesWin
      }
      else {
        this._data.multiply.value = 1
        this._data.multiply.win = 0
      }
    }
    else {
      this._data.multiply.value = 1
      this._data.multiply.win = 0
      this._data.multiply.layoutx = false
      this._data.wild = []
    }

    const isCascade = game.models.CascadeModel.get().isCascade
    if(isCascade){
      this._data.winLines.length = 0
    }

    if(value.stats){
      if(value.stats.respin){
        this._data.respinWin = value.stats.respin.win
      }
    }
  }

  makeWinLines(value, type) {
    this._data[type] = []
    value.forEach((line, index) => {
      this._data[type][index] = {}
      this._data[type][index].id = line.id
      this._data[type][index].win = line.amount
      this._data[type][index].symbol = line.symbol
      this._data[type][index].path = line.positions
    })
  }
}
